Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Groups3400290406",
  {"root":"Groups3400290406--root","header":"Groups3400290406--header","title":"Groups3400290406--title"},
  "",
  9,
  "Groups3400290406"
);

